// extracted by mini-css-extract-plugin
module.exports = {"ClusterMarkers":"ClusterMarker_ClusterMarkers__2tt_K","count":"ClusterMarker_count__3Wi8i","marker":"ClusterMarker_marker__2q78L","dotColor":"ClusterMarker_dotColor__2PUAV"};